import { Injectable } from '@angular/core';
import { BaseModalService } from 'src/app/shared/services/base-modal/base-modal.service';
import { MaintenanceModeConfiguration } from './maintenance-mode-configuration';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceModeNotificationModalService extends BaseModalService<MaintenanceModeConfiguration> {}
